import { acquireTranslationSlot } from "./translationSlots";

const BATCH_SIZE = 5;
export async function translateInBatches<TItem, TTranslation>({
  items,
  translateBatch,
  onBatchTranslated,
}: {
  items: TItem[];
  translateBatch: (batch: TItem[]) => Promise<TTranslation[] | null>;
  onBatchTranslated: (params: { translations: TTranslation[]; batch: TItem[]; batchStartIndex: number }) => void;
}): Promise<{ hasFailedBatch: boolean }> {
  const batches: TItem[][] = [];
  for (let i = 0; i < items.length; i += BATCH_SIZE) {
    batches.push(items.slice(i, i + BATCH_SIZE));
  }

  const results = await Promise.allSettled(
    batches.map(async (batch, batchIndex) => {
      const releaseSlot = await acquireTranslationSlot();
      try {
        const translations = await translateBatch(batch);
        if (translations === null) {
          throw new Error("Batch translation failed");
        }
        onBatchTranslated({ translations, batch, batchStartIndex: batchIndex * BATCH_SIZE });
      } finally {
        releaseSlot();
      }
    })
  );

  return { hasFailedBatch: results.some((result) => result.status === "rejected") };
}
